import { createTheme, Theme, ThemeOptions } from '@mui/material/styles';

import componentStyleOverrides from './compStyleOverride';
import themeTypography from './typography';

export const theme = () => {
    const themeOptions: ThemeOptions = {
        typography: themeTypography()
    };

    const themes: Theme = createTheme(themeOptions);
    themes.components = componentStyleOverrides();

    return themes;
};

export default theme;
